import styled from "styled-components";

import DownloadMessage from "core/DownloadMessage";
import { H2 } from "core/Typography";

import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";
import breakpoints from "core/breakpoints";
import { rapidEasing } from "core/animation";

export const BackLink = styled.button`
    font-size: ${convertPxToRem({ px: 12 })};
    color: ${colors.coin};
    border: 0;
    border-bottom: 1px solid ${colors.coin};
    padding: 0;
    margin-top: ${convertPxToRem({ px: 30 })};
    background-color: transparent;
    cursor: pointer;
    transition: color ${rapidEasing}, border-bottom-color ${rapidEasing};

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        display: none;
    }

    &:hover {
        color: ${colors.mist};
        border-bottom-color: ${colors.mist};
    }
`;

export const StyledProDownloadSection = styled.div`
    ${DownloadMessage} {
        margin-top: 1.4rem;
        margin-bottom: 1.4rem;

        @media (min-width: ${breakpoints.tablet.rem}) {
            margin-top: 0;
        }

        @media (min-width: ${breakpoints.laptop.rem}) {
            margin-top: 1.75rem;
        }
    }
`;

export const StyledPublicDomainDownloadSection = styled.div`
    line-height: 1.5rem;

    ${H2} {
        margin-bottom: 0.25rem;
    }
`;

export const Spacer = styled.div`
    margin-bottom: 1.875rem;

    ${DownloadMessage} {
        @media (max-width: ${breakpoints.beforeTablet.rem}) {
            margin-top: 1.4rem;
            margin-bottom: 1.25rem;
        }
    }
`;
